import { Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import SupplierCard from './SupplierCard'

const useStyles = makeStyles(theme => ({
  countLabel: {
    display: 'none',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      display: 'block',
    },
  },
  supplierCard: {
    marginBottom: theme.spacing(2),
  },
}))

const SuppliersList = ({
  fetching,
  hasNextPage,
  onClickSupplier,
  onFetchMore,
  suppliers,
  total,
  ...props
}) => {
  const classes = useStyles()

  const showingText = fetching
    ? 'Showing...'
    : `Showing ${total} ${total === 1 ? 'company' : 'companies'}`

  return (
    <div>
      <Typography
        className={classes.countLabel}
        variant="body2"
        color="textSecondary"
      >
        {showingText}
      </Typography>
      {!fetching && (
        <InfiniteScroll
          dataLength={suppliers.length}
          next={onFetchMore}
          hasMore={hasNextPage}
        >
          {suppliers.map(supplier => (
            <SupplierCard
              {...supplier}
              className={classes.supplierCard}
              key={supplier.id}
              onClick={() => onClickSupplier(supplier.id)}
              {...props}
            />
          ))}
        </InfiniteScroll>
      )}
    </div>
  )
}

SuppliersList.defaultProps = {
  hasNextPage: false,
  suppliers: [],
  total: 0,
}

export default SuppliersList
